import { MagnifyingGlass } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { useGetInCompletedTodosQuery } from "../features/api/apiSlice";
import NoDataFound from "./NoDataFound";
import Todo from "./Todo";

export default function TodoList() {
    const { inCompleteFilter: colors } = useSelector((state) => state.filter);
    const { data: inCompletedTodos = [], isLoading } = useGetInCompletedTodosQuery(colors);

    return (
        <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">

            {isLoading ? <div className="flex justify-center align-center">
                <MagnifyingGlass
                    visible={true}
                    height="150"
                    width="150"
                    ariaLabel="MagnifyingGlass-loading"
                    wrapperStyle={{}}
                    wrapperClass="MagnifyingGlass-wrapper"
                    glassColor='#c0efff'
                    color='#e15b64'
                />
            </div> : inCompletedTodos.length > 0 ? inCompletedTodos.map((todo) => (
                <Todo todo={todo} key={todo.id} />
            )) : <NoDataFound />}

        </div>
    );
}
